/* eslint-disable */
export interface ImportTranslationResultViewModel {
    importedDateTime: string;
    saveAndPublishTranslatedContentResult: SaveAndPublishTranslatedContentResult;
}
export interface TranslationJobListItemViewModel {
    jobId: string;
    lastImported: string;
    lastSaved: string;
    projectId: string;
    status: string;
    targetLanguage: string;
}
export interface TranslationProjectListItemViewModel {
    name: string;
    numberOfJobs: number;
    pageId: number;
    projectId: string;
    projectStatus: string;
    sourceLanguage: string;
}
export interface TranslationProjectTemplateViewModel {
    id: string;
    sourceLanguage: string;
    targetLanguages: string[];
    templateName: string;
}
export interface BaseContentModel {
    blocks: JsonContent[];
    blocksBelow: JsonContent[];
}
export interface SaveAndPublishTranslatedContentResult {
    isPublished: boolean;
    languageVariantSaveAndPublishResults: SaveAndPublishTranslatedContentResult[];
    publishFailed: boolean;
    targetLanguage: string;
    translationJobId: string;
}
export interface BasketPageViewModel extends BaseContentModel {
}
export interface BecomeACustomerViewModel extends BaseContentModel {
    areaOfInterest: string[];
    becomeCustomerPostFinishSteps: JsonContent[];
    image: Media;
    imageText: string;
    showCrn: boolean;
}
export interface BecomeCustomerPostFinishStepViewModel {
    headline: string;
    icon: Media;
    text: string;
}
export interface BrandPageViewModel extends BaseContentModel {
    brandName: string;
    listAllProducts: boolean;
}
export interface BrandSearchPageLinkViewModel {
    brandName: string;
    links: BrandSearchPageLinkViewObject[];
}
export interface BrandSearchPageLinkViewObject {
    categoryIds: string[];
    displayName: string;
    pageName: string;
    url: string;
}
export interface BrandSearchPageViewModel extends BaseContentModel {
    brandName: string;
    categoryIds: string[];
    displayName: string;
}
export interface BrandsViewModel extends BaseContentModel {
}
export interface CampaignBlockViewModel {
    buttonText: string;
    campaignName: string;
    campaignUrl: string;
    categories: string[];
    endDate: string;
    iconUrl: string;
    id: number;
    image: Media;
    showIcon: boolean;
    startDate: string;
    teaser: string;
}
export interface CampaignPageViewModel extends BaseContentModel {
    buttonText: string;
    campaignName: string;
    campaignText: string;
    categories: string[];
    image: Media;
    listAllProducts: boolean;
}
export interface CampaignsViewModel extends BaseContentModel {
    campaignPageSize: number;
    campaigns: CampaignBlockViewModel[];
    categories: string[];
    count: number;
    firstCampaign: CampaignBlockViewModel;
    headline: string;
}
export interface CategoryPageViewModel extends BaseContentModel {
    categoryId: number;
    listAllProducts: boolean;
}
export interface CategorySeoInformationViewModel {
    seoDescription: string;
    seoTitle: string;
}
export interface DepartmentsViewModel extends BaseContentModel {
}
export interface EmailViewModel {
    modules: JsonContent[];
    preheader: string;
    subject: string;
}
export interface FooterCompanyDetails {
    addressInformation: string;
    city: string;
    companyName: string;
    email: string;
    openingHours: string;
    phoneNumber: string;
    postalCode: string;
    vatNumber: string;
}
export interface FooterSitemapColumnViewModel {
    links: NameAndUrl[];
    socialMediaLinks: IconNameAndUrl[];
    title: string;
}
export interface FrontpageViewModel extends BaseContentModel {
}
export interface News {
    categories: string[];
    date: string;
    header: string;
    id: number;
    image: Media;
    teaser: string;
    url: NameAndUrl;
}
export interface NewsArticlePageViewModel extends BaseContentModel {
    articleText: string;
    campaignLink: Link;
    categories: string[];
    date: Date;
    dateFormatted: string;
    header: string;
    image: Media;
    pressMaterial: Media[];
    pressRelease: boolean;
    relatedLinks: Link[];
}
export interface NewsPageViewModel extends BaseContentModel {
    categories: string[];
    count: number;
    firstNews: News;
    headline: string;
    news: News[];
    newsPageSize: number;
}
export interface NotificationsViewModel {
    anonymous: JsonContent;
    authenticated: JsonContent;
    employees: JsonContent;
}
export interface Product404PageViewModel extends BaseContentModel {
}
export interface ProductDetailsPageViewModel {
    recommendations: JsonContent[];
    seoDescription: string;
    seoTitles: string[];
}
export interface ResourceMenuBannerViewModel {
    callToActionLink: NameAndUrl | null;
    headline: string | null;
    image: Media | null;
    text: string | null;
}
export interface ResourceMenuItemGroupViewModel {
    groupUrl: string | null;
    headline: string | null;
    icon: Media | null;
    links: NameAndUrl[] | null;
}
export interface ResourceMenuViewModel {
    resourceMenuBanner: ResourceMenuBannerViewModel | null;
    resourceMenuItemGroups: ResourceMenuItemGroupViewModel[] | null;
}
export interface RMAPageViewModel {
    rmaFrontpageBlocks: JsonContent[];
    rmaReceiptPageBlocks: JsonContent[];
}
export interface SettingsViewModel {
    accessRequestPage: string;
    basketPage: string;
    becomeACustomerPage: string;
    brandsPage: string;
    campaignPage: string;
    dataProcessingAgreementPage: string;
    departmentPage: string;
    directDebitPage: string;
    enableClientSideLogging: boolean;
    financialDepartment: string;
    menuCampaignIcon: string;
    menuCampaignLink: Link;
    newsPage: string;
    notificationsLink: string;
    orderIntegrationPage: string;
    priceFilesPage: string;
    product404Page: string;
    productDetailsPage: string;
    productGuidePage: string;
    productGuideSpecificGuidePage: string;
    productListContentPlacementIndex: number;
    receiptPage: string;
    rmaPage: string;
    salesAndSupportPage: string;
    standardFreightPage: string;
    termsPage: string;
}
export interface SiteChromeViewModel {
    resourceMenu: ResourceMenuViewModel;
    settings: SettingsViewModel;
    siteFooter: SiteFooterViewModel;
}
export interface SiteFooterViewModel {
    companyDetails: FooterCompanyDetails;
    sitemapColumns: FooterSitemapColumnViewModel[];
}
export interface BreadcrumbItem {
    id: string;
    name: string;
    page?: string;
    url: string;
}
export interface IconNameAndUrl {
    icon: string;
    name: string;
    target: string;
    url: string;
}
export interface JsonContent {
    alias: string;
    content: any;
    name: string;
}
export interface LanguageAndUrl {
    language: string;
    url: string;
}
export interface Link {
    name: string;
    target: string;
    type: LinkType;
    url: string;
}
export interface Media extends NameAndUrl {
    extension: string;
    focalPoint: ImageCropperFocalPoint;
    height: number;
    width: number;
}
export interface Metadata {
    id: number;
    index: boolean;
    key: string;
    languages: LanguageAndUrl[];
    navigationTitle: string;
    seoDescription: string;
    seoImage: Media;
    seoTitle: string;
    url: string;
}
export interface NameAndUrl {
    name: string;
    target: string;
    url: string;
}
export interface Navigation {
    breadcrumb: BreadcrumbItem[];
    leftMenu: NavigationItem[];
}
export interface NavigationItem {
    children: NavigationItem[];
    id: string;
    name: string;
    url: string;
}
export interface PageData {
    jsonContent: JsonContent;
    metadata: Metadata;
    navigation: Navigation;
}
export interface PreviewModel {
    apiHost: string;
    assets: { [key: string]: string };
    assetsUrl: string;
    businessEntityName: string;
    clientAssetsUrl: string;
    contentHost: string;
    countryCode: string;
    cssFiles: string[];
    culture: string;
    currentPath: string;
    customCulture: string;
    devServerUrl: string;
    dictionary: string;
    erpBusinessEntityId: number;
    externalProductGuideLink: string;
    externalProductGuideLinkText: string;
    googleTagManagerId: string;
    isExternalProductGuide: boolean;
    jsFiles: string[];
    languageCode: string;
    marketId: number;
    pageData: PageData;
    siteChromeJson: any;
    siteId: number;
    url: string;
}
export interface ImageCropperFocalPoint {
    left: number;
    top: number;
}
export interface EmailBreaker3ElementsViewModel {
}
export interface EmailBreaker4ElementsViewModel {
}
export interface EmailBreakerOneLineViewModel {
    backgroundColor: string;
    header: string;
    headerColor: string;
    headerSize: string;
}
export interface EmailFullWidthTestimonialViewModel {
    backgroundColor: string;
    bodyText: string;
    bodyTextColor: string;
    bodyTextSize: string;
    cleanBodyText: string;
    header: string;
    headerColor: string;
    headerSize: string;
    image: Media;
    imageText1: string;
    imageText2: string;
    imageTextColor: string;
}
export interface EmailHeroBannerViewModel {
    backgroundColor: string;
    backgroundImage: Media;
    callToAction: Link;
    callToActionColor: string;
    callToActionTextColor: string;
    caption: string;
    captionColor: string;
    cleanSubheader: string;
    contentBackgroundColor: string;
    contentBackgroundColorTransparent: boolean;
    header: string;
    headerColor: string;
    headerSize: string;
    shim: boolean;
    subheader: string;
    subheaderColor: string;
    subheaderSize: string;
}
export interface EmailImageBannerViewModel {
    image: Media;
    link: Link;
}
export interface EmailImageTextBlockViewModel {
    bodyText: string;
    bodyTextColor: string;
    bodyTextSize: string;
    bullets: JsonContent[];
    callToAction: Link;
    callToActionColor: string;
    callToActionTextColor: string;
    cleanBodyText: string;
    cleanSubheader: string;
    header: string;
    headerColor: string;
    headerSize: string;
    image: Media;
    imageAlignment: string;
    imageWidth: string;
    subheader: string;
    subheaderColor: string;
    subheaderSize: string;
}
export interface EmailPersonalizedContentBannerViewModel {
    adUnitId: PersonalizedContentModel;
}
export interface EmailPersonalizedContentBrandBlocksViewModel {
    backgroundColor: string;
    textColor: string;
}
export interface EmailPersonalizedContentDepartmentsViewModel {
    adUnitId: PersonalizedContentModel;
}
export interface EmailProductBlocksViewModel {
    blocks: JsonContent[];
}
export interface EmailTextBlockViewModel {
    bodyText: string;
    bodyTextColor: string;
    bodyTextSize: string;
    callToAction: Link;
    callToActionColor: string;
    callToActionTextColor: string;
    cleanBodyText: string;
    cleanSubheader: string;
    header: string;
    headerColor: string;
    headerSize: string;
    subheader: string;
    subheaderColor: string;
    subheaderSize: string;
    textAlignment: string;
}
export interface EmailThreeStepBlockViewModel {
    backgroundColor: string;
    header: string;
    headerColor: string;
    headerSize: string;
    image: Media;
    imageLink: Link;
    steps: JsonContent[];
    stepsColor: string;
}
export interface EmailUspBlockViewModel {
    backgroundColor: string;
    caption: string;
    captionColor: string;
    uspItems: JsonContent[];
}
export interface AdUnitIdContentModel {
    adUnitId: string;
    id: number;
    name: string;
}
export interface PersonalizedContentModel {
    selectedAdUnitIdContent: AdUnitIdContentModel;
}
export interface BulletViewModel {
    color: string;
    text: string;
    type: string;
}
export interface EmailProductViewModel {
    block: ProductBlockModel;
}
export interface NestedBulletViewModel {
    value: string;
}
export interface StepViewModel {
    bodyText: string;
    cleanBodyText: string;
    cleanHeader: string;
    header: string;
}
export interface UspItemViewModel {
    callToAction: Link;
    callToActionColor: string;
    callToActionTextColor: string;
    headline: string;
    icon: Media;
    shortText: string;
}
export interface Image {
    extension: string;
    isOriginIceCat: boolean;
    name: string;
    sortOrder: any;
    uri: string;
}
export interface ProductBlockModel {
    brand: string;
    categoryId: string;
    description: string;
    displayName: string;
    image: Image;
    inStock: number;
    itemId: string;
    mpn: string;
    name: string;
    showPrice: boolean;
    title: string;
    url: string;
    wid: string;
}
export enum ContentWidth {
    FullWidth = 0,
    TwoThird = 1,
    OneThird = 2
}
export enum HorizontalAlignment {
    Left = 0,
    Right = 1
}
export enum SubheaderFontSize {
    Normal = 0,
    Large = 1
}
export interface BaseBlockViewModel {
    anchorLink: string;
    backgroundColor: string;
    backgroundImage: Media;
    backgroundImageBehavior: string;
    callToAction: Link;
    callToActionColor: string;
    caption: string;
    captionColor: string;
    captionLocation: string;
    contentBackgroundColor: string;
    header: string;
    headerColor: string;
    isBackgroundVideo: boolean;
    makeContentBackgroundTransparent: boolean;
    shimColor: string;
    showVideoControls: boolean;
    subheader: string;
    subheaderColor: string;
    video: Media;
    vimeoVideoId: string;
}
export interface BaseTextBlockViewModel {
    anchorLink: string;
    backgroundColor: string;
    bodyText: string;
    callToAction: Link;
    callToActionColor: string;
    customBackgroundColor: string;
    headline: string;
}
export interface BecomeACustomerBlockViewModel {
    anchorLink: string;
    appendToPreviousBlock: boolean;
    headline: string;
    info: string;
    origin: string;
    remark: string;
    subtitle: string;
}
export interface BecomeAResellerBlockViewModel {
    anchorLink: string;
    appendToPreviousBlock: boolean;
    headline: string;
    informationBoxBullets: JsonContent[];
    informationBoxHeadline: string;
    origin: string;
    receiptBody: string;
    receiptHeadline: string;
    receiptImage: Media;
    receiptImageContent: string;
    receiptImageHeadline: string;
    showCrnField: boolean;
}
export interface BrandRecommendationsBlockViewModel {
    anchorLink: string;
    appendToPreviousBlock: boolean;
    brandCount: number;
    brandId: string;
    brandIdFilterList: string[];
    categoryIdFilterNegativeList: string[];
    categoryIdFilterPositiveList: string[];
    displayLocation: string;
    headline: string;
    interval: number;
    isSimpleView: boolean;
    popularity: number;
    type: number;
    useDiverseRecommendations: boolean;
}
export interface BrandsBlockViewModel {
    anchorLink: string;
    appendToPreviousBlock: boolean;
    headline: string;
    linkText: string;
}
export interface CableGuideBlockViewModel {
    anchorLink: string;
    appendToPreviousBlock: boolean;
    productPageSize: number;
}
export interface CancelNewsletterBlockViewModel {
    anchorLink: string;
    appendToPreviousBlock: boolean;
    headline: string;
    subtitle: string;
}
export interface CategoryBlockViewModel {
    anchorLink: string;
    appendToPreviousBlock: boolean;
    backgroundColor: string;
    customBackgroundColor: string;
    headline: string;
    settings: PersonalizedContentModel;
}
export interface CategoryRecommendationsBlockViewModel {
    anchorLink: string;
    appendToPreviousBlock: boolean;
    brandId: string;
    brandIdFilterList: string[];
    categoryCount: number;
    categoryIdFilterNegativeList: string[];
    categoryIdFilterPositiveList: string[];
    displayLocation: string;
    headline: string;
    interval: number;
    popularity: number;
    type: number;
}
export interface CategoryTileBlockViewModel {
    anchorLink: string;
    headline: string;
    imageMode: string;
    tiles: JsonContent[];
}
export interface CategoryTileViewModel {
    buttonFullWidth: boolean;
    callToAction: Link;
    description: string;
    headline: string;
    image: Media;
}
export interface CodeBlockViewModel {
    anchorLink: string;
    appendToPreviousBlock: boolean;
    author: string;
    code: string;
    description: string;
    heading: string;
}
export interface EmployeesBlockViewModel {
    employeeNumbers: string[];
    headline: string;
}
export interface FaqBlockItemViewModel {
    answer: string;
    question: string;
}
export interface FaqBlockViewModel {
    faqs: JsonContent[];
    headline: string;
}
export interface FullWidthTextBlockViewModel extends BaseTextBlockViewModel {
    appendToPreviousBlock: boolean;
}
export interface HalfWidthBlocksViewModel {
    anchorLink: string;
    appendToPreviousBlock: boolean;
    blocks: JsonContent[];
}
export interface HalfWidthBlockViewModel extends BaseBlockViewModel {
}
export interface HeroBannerUspItemViewModel {
    icon: Media;
    text: string;
}
export interface HeroBannerViewModel extends BaseBlockViewModel {
    appendToPreviousBlock: boolean;
    contentAligmentValue: HorizontalAlignment;
    contentWidthValue: ContentWidth;
    subheaderFontSizeValue: SubheaderFontSize;
}
export interface HeroBannerWithUspBlockViewModel {
    backgroundImage: Media;
    callToAction: Link;
    callToActionColor: string;
    header: string;
    headerColor: string;
    mobileVimeoVideoId: string;
    shimColor: string;
    showUspItemsOnMobile: boolean;
    subheader: string;
    uspItems: JsonContent[];
    vimeoVideoId: string;
}
export interface IframeBlockViewModel {
    anchorLink: string;
    headline: string;
    iframeTitle: string;
    iframeUrl: string;
}
export interface JotFormBlockViewModel {
    allowFullscreen: boolean;
    allowScrolling: boolean;
    allowTransparency: boolean;
    anchorLink: string;
    headline: string;
    jotFormId: string;
}
export interface LatestCampaignsBlockViewModel {
}
export interface LatestNewsBlockViewModel {
    anchorLink: string;
}
export interface MapBlockViewModel {
    anchorLink: string;
    mapLocations: JsonContent[];
    mapType: string;
    maxZoom: number;
    minZoom: number;
}
export interface MapLocationBlockViewModel {
    address: string;
    businessEntityID: string;
    country: string;
    email: string;
    gpsLatitude: string;
    gpsLongitude: string;
    groupName: string;
    link: Link;
    locationType: string;
    phoneNumber: string;
    postalCodeAndCity: string;
}
export interface PersonalizedContentBlockViewModel {
    anchorLink: string;
    appendToPreviousBlock: boolean;
    settings: PersonalizedContentModel;
}
export interface ProductCategoriesViewModel {
    anchorLink: string;
    header: string;
}
export interface ProductGuideBlockViewModel {
    anchorLink: string;
    appendToPreviousBlock: boolean;
    guideId: string;
    productGuideTitle: string;
    productPageSize: number;
    searchContent: string;
    searchHeadline: string;
    startInStepByStep: boolean;
    stepByStepContent: string;
    stepByStepHeadline: string;
}
export interface ProductGuideConfigurationBlockViewModel {
    anchorLink?: string;
    blocks?: JsonContent[];
    confirmText?: string;
    headline: string;
    introductionText?: string;
    successText?: string;
}
export interface ProductListBlockViewModel {
    anchorLink: string;
    header: string;
    productBackgroundColor: string;
    productIds: string[];
}
export interface ProductRecommendationsBlockViewModel {
    allowFillIfNecessary: boolean;
    anchorLink: string;
    appendToPreviousBlock: boolean;
    brandId: string;
    brandIdFilterList: string[];
    categoryId: string;
    categoryIdFilterNegativeList: string[];
    categoryIdFilterPositiveList: string[];
    displayLocation: string;
    hasImages: boolean;
    headline: string;
    interval: number;
    popularity: number;
    productBackgroundColor: string;
    productCount: number;
    showFeedProducts: boolean;
    stockFilter: number;
    type: number;
    useListView: boolean;
}
export interface QuoteBlockViewModel {
    anchorLink: string;
    appendToPreviousBlock: boolean;
    author: string;
    backgroundColor: string;
    customBackgroundColor: string;
    quote: string;
}
export interface RecentlyViewedProductsViewModel {
    anchorLink: string;
    recentlyViewedHeader: string;
}
export interface SimpleUspBlockViewModel {
    appendToPreviousBlock: boolean;
    backgroundColor: string;
    showBlockOnMobile: boolean;
    textColor: string;
    uniqueSellingPointItems: JsonContent[];
}
export interface StatisticBlockItemViewModel {
    animationDurationMS: number;
    color: string;
    customColor: string;
    statistic: string;
    value: number;
    valuePrefix: string;
    valueSuffix: string;
}
export interface StatisticsBlockViewModel {
    appendToPreviousBlock: boolean;
    backgroundColor: string;
    customBackgroundColor: string;
    statistics: JsonContent[];
}
export interface StepBlockViewModel {
    description: string;
    headline: string;
    icon: Media;
}
export interface StepsBlockViewModel {
    stepItems: JsonContent[];
}
export interface SubscribeNewsletterBlockViewModel {
    anchorLink: string;
    appendToPreviousBlock: boolean;
}
export interface TabbedContentBlockViewModel {
    anchorLink: string;
    tabs: JsonContent[];
}
export interface TabbedContentViewModel {
    anchorLink: string;
    blocks: JsonContent[];
    headline: string;
    keepAlive: boolean;
}
export interface TextBlockViewModel extends BaseTextBlockViewModel {
}
export interface TextWithImageBlockViewModel {
    anchorLink: string;
    callToAction: Link;
    callToActionColor: string;
    headline: string;
    headlineColor: string;
    image: Media;
    placeImageRight: boolean;
    subHeadline: string;
    subHeadlineColor: string;
    text: string;
    textColor: string;
}
export interface TwoPlusOneBlocksViewModel {
    anchorLink: string;
    appendToPreviousBlock: boolean;
    halfWidthBlocks: JsonContent[];
    largeBlock: JsonContent[];
    largeBlockAlignmentValue: HorizontalAlignment;
}
export interface UniqueSellingPointBlocksViewModel {
    anchorLink: string;
    appendToPreviousBlock: boolean;
    backgroundColor: string;
    customBackgroundColor: string;
    headline: string;
    uniqueSellingPointItems: JsonContent[];
}
export interface UniqueSellingPointItemViewModel {
    anchorLink: string;
    headline: string;
    icon: Media;
    iconBackgroundColor: string;
    link: Link;
    shortText: string;
}
export interface WebsiteNotificationViewModel {
    endDate: Date;
    message: string;
    startDate: Date;
}
export interface ProductGuideSettingsViewModel {
    confirmText: string;
    introductionText: string;
    successText: string;
}
export interface EmailLaunchStatusViewModel {
    launchDate: string;
    message: string;
    status: string;
    timeOfDay: string;
}
export interface DictionaryViewModel {
    created: Date;
    cultureName: string;
    dictionaryKey: string;
    dictionaryValues: { [key: string]: string };
}
export interface KeyValuePair<TKey, TValue> {
    key: TKey;
    value: TValue;
}
export enum LinkType {
    Content = 0,
    Media = 1,
    External = 2
}

